import { useNavigate } from 'react-router';
import { useContext, useState } from 'react';
import { Button, Switch } from '@chakra-ui/react';
import actualizarMorosidad from '../../../../services/actualizarMorosidad';
import UserContext from '../../../../context/userContext';
import { useTranslation } from 'react-i18next';

export default function CeldaSocioAdmin({ socio, setSocios }) {
  const { t } = useTranslation();
  const { user, setIsLoadingContext } = useContext(UserContext);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(socio.moroso);

  const handleMorosidad = () => {
    setIsLoadingContext(true);
    actualizarMorosidad(user.id, socio.id, 'Razon')
      .then((res) => {
        if (res.status === 200) {
          setSocios(res.data.titulares);
          setChecked(!socio.moroso);
        } else {
          setChecked(socio.moroso);
        }
        setIsLoadingContext(false);
      })
      .catch((err) => {
        console.error(err);
        setIsLoadingContext(false);
      });
  };
  return (
    <tr>
      <td className="col-sm px-sm-2">{`${socio.nombre} ${socio.apellidos}`}</td>
      <td className="col-sm px-sm-2">
        {!socio.coTitular ? t('HOLDER') : t('CO_HOLDER')}
      </td>
      <td className="col-sm px-sm-2">{socio.tipoCabana}</td>
      <td className="col-sm px-sm-2">{socio.membresia}</td>
      <td className="col-sm px-sm-2">{socio.fechaFirma.split('T')[0]}</td>
      <td className="col-sm px-sm-2">{socio.vecesMoroso}</td>
      <td className="col-sm px-sm-2">
        <Switch
          id="id"
          isChecked={checked}
          onChange={handleMorosidad}
          isDisabled={socio.coTitular}
        />
      </td>
      <td>
        <Button
          onClick={() => navigate(`/titular/${socio.id}`)}
          colorScheme="green"
        >
          {t('EDIT')}
        </Button>
        <Button
          onClick={() => navigate(`/membresia/${socio.id}`)}
          ml={2}
          backgroundColor={'#e06c00'}
          color={'white'}
          onMouseOver={(e) => (e.target.style.backgroundColor = '#d65f00')}
          onMouseOut={(e) => (e.target.style.backgroundColor = '#e06c00')}
        >
          {t('VIEW_MEMBERSHIP')}
        </Button>
      </td>
    </tr>
  );
}
